import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Urls } from './Urls';
import * as CryptoJS from 'crypto-js';
import { Variables } from './variables';
import { tap, shareReplay } from 'rxjs/operators';

export class DataCache {
    static groupdata$: Observable<any>;
    static grouptypedata$: Observable<any>;

    static groupData: any;
    static groupTypeData: any;

    static url = new Urls();
    static http: any;

    constructor(private ht: HttpClient) {
        DataCache.http = ht;
    }

    static loadData(ht: HttpClient) {
        DataCache.http = ht;
        const apiUrl = this.url.apiUrl;

        const v = new Variables();
        const val = localStorage.getItem('oi');
        if (val === undefined || val === null) {
          return;
        }
        const oi = CryptoJS.AES.decrypt(val, v.pass).toString(CryptoJS.enc.Utf8);

        const orgId = +oi;

        const page = 0;
        const size = 0;

        // get groups
        this.groupdata$ = this.http.get(apiUrl + '/api/groups/' + orgId).pipe(
          tap(),
          shareReplay(1),
          tap()
        );

        // get group typess
        this.grouptypedata$ = this.http.get(apiUrl + '/api/grouptype').pipe(
          tap(),
          shareReplay(1),
          tap()
        );
    }

    getGroupData() {
      DataCache.groupdata$.subscribe(data => DataCache.groupData = data);
    }

    getGroupTypeData() {
      DataCache.grouptypedata$.subscribe(data => DataCache.groupTypeData = data);
    }

    clearData() {
        DataCache.groupData = null;
        DataCache.groupTypeData = null;
    }
}
